import type { FC } from 'react';
import { memo } from 'react';
import dayjs from 'dayjs';

import ModalHeader from '@trend-dev/trendtech-ui/components/UI/Modal/ModalHeader';

import { useTimerStore } from 'store/timer';

import { getAlmostOverTitle } from '../const';

const Header: FC = () => {
    const { notification } = useTimerStore();

    if (!notification) return null;

    return (
        <ModalHeader hideButton>
            <h4 className='d-4'>{getAlmostOverTitle(dayjs(notification).get('minutes'))}</h4>
        </ModalHeader>
    );
};

export default memo(Header);
